import React from "react";
import { Field } from "formik";
import { useField } from 'formik';
import l from "components/util/l"
import BaseField from "components/util/schema_form/fields/BaseField";


const NumberField = ({
	name,
	label,
	value,
	values,
	required,
	disabled,
	caption,
	helpMessage,
	allowDecimals, // Decimal or Integer
	minValue, // Lower range for the number field
	maxValue, // Upper range for the number field
	step, // Step for the number field
	placeholder,
	enableComments,
	setFieldValue
}) => {

	const [field, meta, helpers] = useField(name);
	const currentValue = field.value;
	const regex = allowDecimals ? /^-?\d*(\.\d*)?$/ : /^-?\d*$/;

	const handleChange = (e) => {
		const inputVal = e.target.value;
		if (inputVal == '' || regex.test(inputVal)) {
			setFieldValue(name, inputVal);
		}
	};

	const getDecimalPlaces = (num) => {
		if (!num || Number.isInteger(num)) return 0;
		const parts = num.toString().split('.');
		return parts.length > 1 ? parts[1].length : 0;
	};

	const roundToStep = (value, step) => {
		const decimals = getDecimalPlaces(step);
		return parseFloat(value.toFixed(decimals));
	};

	const increment = () => {
		let newVal = parseFloat(currentValue || 0) + parseFloat(step);
		if (maxValue !== undefined && newVal > maxValue) newVal = maxValue;
		if (!allowDecimals) newVal = Math.round(newVal);
		else newVal = roundToStep(newVal, step);
		setFieldValue(name, newVal);
	};

	const decrement = () => {
		let newVal = parseFloat(currentValue || 0) - parseFloat(step);
		if (minValue !== undefined && newVal < minValue) newVal = minValue;
		if (!allowDecimals) newVal = Math.round(newVal);
		else newVal = roundToStep(newVal, step);
		setFieldValue(name, newVal);
	};

	return (
		<BaseField
			name={name}
			label={label}
			values={values}
			required={required}
			caption={caption}
			helpMessage={helpMessage}
			enableComments={enableComments}
			setFieldValue={setFieldValue}
		>
			<div class="input-group-quantity-counter w-100">
				<input
					id={name}
					name={name}
					type="number"
					value={value}
					onChange={handleChange}
					onBlur={field.onBlur}
					disabled={disabled}
					min={minValue}
					max={maxValue}
					step={step}
					autocomplete="off"
					placeholder={l(placeholder)}
					className="form-control input-group-quantity-counter-control"
					style={{ paddingLeft: "1.2rem", paddingRight: "1.2rem" }}
				/>

				<div class="input-group-quantity-counter-toggle">
					<button type="button" class="input-group-quantity-counter-btn mr-1" onClick={decrement} disabled={disabled}>
						<i class="tio-remove"></i>
					</button>
					<button type="button" class="input-group-quantity-counter-btn" onClick={increment} disabled={disabled}>
						<i class="tio-add"></i>
					</button>
				</div>
			</div>
		</BaseField>
	)
}

export default NumberField;